/**
 * Canvas UI State Schemas
 * Frontend-only state (not persisted to backend)
 */

import { z } from 'zod';

// ========================================
// VIEWPORT STATE (Frontend-only)
// ========================================

export const ViewportStateSchema = z.object({
  x: z.number().describe('Viewport X position'),
  y: z.number().describe('Viewport Y position'),
  zoom: z.number().min(0.33).max(2.0).describe('Zoom level (0.33 = 3x zoom out, 2.0 = 2x zoom in) - Magic Canvas default'),
  isDragging: z.boolean().optional().describe('Whether the viewport is being dragged'),
});

// ========================================
// SIDEBAR STATE (Frontend-only)
// ========================================

export const SidebarPanelSchema = z.object({
  id: z.string().describe('Panel identifier (e.g., "properties", "layers", "history")'),
  isOpen: z.boolean().describe('Whether the panel is currently open'),
  data: z.unknown().optional().describe('Panel-specific data'),
});

export const SidebarStateSchema = z.object({
  panels: z.array(SidebarPanelSchema).describe('All sidebar panels'),
  activePanel: z.string().optional().describe('Currently active/focused panel ID'),
});

// ========================================
// TYPE EXPORTS
// ========================================

export type ViewportState = z.infer<typeof ViewportStateSchema>;
export type SidebarPanel = z.infer<typeof SidebarPanelSchema>;
export type SidebarState = z.infer<typeof SidebarStateSchema>;
